import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/LoginForm';
import ContentEditor from '../components/admin/ContentEditor';
import GalleryManager from '../components/admin/GalleryManager';
import ReviewsManager from '../components/admin/ReviewsManager';

const TABS = [
  { id: 'content', label: 'Seiteninhalte' },
  { id: 'gallery', label: 'Galerie' },
  { id: 'reviews', label: 'Bewertungen' },
];

export default function AdminPage() {
  const { isLoggedIn, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('content');

  if (!isLoggedIn) return <LoginForm />;

  return (
    <main style={styles.page}>
      <div style={styles.inner}>
        <div style={styles.header}>
          <h1 style={styles.heading}>CMS – Admin-Bereich</h1>
          <button style={styles.logoutBtn} onClick={logout}>Abmelden</button>
        </div>

        <div style={styles.tabs}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              style={{ ...styles.tab, ...(activeTab === tab.id ? styles.tabActive : {}) }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div style={styles.content}>
          {activeTab === 'content' && <ContentEditor />}
          {activeTab === 'gallery' && <GalleryManager />}
          {activeTab === 'reviews' && <ReviewsManager />}
        </div>
      </div>
    </main>
  );
}

const styles = {
  page: { backgroundColor: '#f4faf5', minHeight: '100vh', padding: '2rem 1.5rem' },
  inner: { maxWidth: '900px', margin: '0 auto' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' },
  heading: { color: '#333', fontFamily: 'Arial, sans-serif', fontSize: '1.6rem', margin: 0 },
  logoutBtn: { backgroundColor: 'transparent', color: '#dc3545', border: '1px solid #dc3545', borderRadius: '5px', padding: '0.4rem 1rem', cursor: 'pointer', fontFamily: 'Arial, sans-serif', fontSize: '0.9rem' },
  tabs: { display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', borderBottom: '2px solid #ddd' },
  tab: { backgroundColor: 'transparent', border: 'none', borderBottom: '3px solid transparent', padding: '0.7rem 1.2rem', cursor: 'pointer', fontFamily: 'Arial, sans-serif', fontSize: '0.95rem', color: '#666', marginBottom: '-2px' },
  tabActive: { color: '#28a745', borderBottomColor: '#28a745', fontWeight: '700' },
  content: { paddingTop: '0.5rem' },
};
